import { render, staticRenderFns } from "./BusinessPartnerAddressList.vue?vue&type=template&id=a7eafbd6&"
import script from "./BusinessPartnerAddressList.vue?vue&type=script&lang=js&"
export * from "./BusinessPartnerAddressList.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPartnerAddressList.vue?vue&type=style&index=0&id=a7eafbd6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports